var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMolliesIcoRed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1000,
    height: 192,
    viewBox: "0 0 1000 192",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.62 156.04V172.84L24 173.21H40.8L23.62 156.04Z",
    fill: "#E62533"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.62 111.56V128.36L68.47 173.21H85.27L23.62 111.56Z",
    fill: "#E62533"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.62 67.09V83.89L112.95 173.21H129.75L23.62 67.09Z",
    fill: "#E62533"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.62 39.41L157.43 173.21H174.05L23.62 22.79V39.41Z",
    fill: "#E62533"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M173.4 25.45L113.77 85.07L116.86 88.25L173.4 31.72V25.45Z",
    fill: "#E62533"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M173.4 60.46V53.5L127.59 99.31L131.02 102.83L173.4 60.46Z",
    fill: "#E62533"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M173.4 89.2V82.24L141.75 113.89L145.18 117.42L173.4 89.2Z",
    fill: "#E62533"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M173.4 117.94V110.99L155.91 128.47L159.34 132L173.4 117.94Z",
    fill: "#E62533"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M173.4 139.73L170.07 143.05L173.4 146.47V139.73Z",
    fill: "#E62533"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M298.72 105.71L279 53.46H256.93V147.02H277.56V101.09L291.31 138.84H306.13L319.88 101.09V147.02H340.51V53.46H318.44L298.72 105.71Z",
    fill: "#E62533"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M426.44 52.44C418.41 52.44 411.25 54.11 404.56 57.52C390.57 64.58 382.22 80.56 382.22 100.24C382.22 110.64 384.29 119.58 388.36 126.81C396.36 140.9 409.17 148.04 426.44 148.04C434.63 148.04 441.8 146.42 448.36 143.08C462.33 135.73 470.67 119.72 470.67 100.24C470.67 89.99 468.56 81.05 464.41 73.68C456.75 59.78 443.63 52.44 426.44 52.44ZM426.44 128.69C419.7 128.69 414.23 126.38 409.74 121.65C405.34 116.89 403.11 109.69 403.11 100.24C403.11 90.79 405.34 83.58 409.73 78.84C414.23 74.1 419.7 71.79 426.44 71.79C433.21 71.79 438.64 74.09 443.03 78.84C447.5 83.55 449.77 90.75 449.77 100.24C449.77 109.73 447.5 116.93 443.01 121.65C438.63 126.39 433.21 128.69 426.44 128.69Z",
    fill: "#E62533"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M532.11 53.46H511.47V147.02H570.1V127.67H532.11V53.46Z",
    fill: "#E62533"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M631.54 53.46H610.9V147.02H669.54V127.67H631.54V53.46Z",
    fill: "#E62533"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M730.98 53.46H710.34V147.02H730.98V53.46Z",
    fill: "#E62533"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M795.73 106.98H826.82V87.62H795.73V72.82H834.5V53.46H775.1V147.02H835.78V127.67H795.73V106.98Z",
    fill: "#E62533"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M863.76 88.75H879.39L900.91 53.53H875.02L863.76 88.75Z",
    fill: "#E62533"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M950.35 89.48C942.08 85.57 938.06 81.8 938.06 77.98C938.06 74.33 940.76 71.79 944.63 71.79C948.85 71.79 952.42 74.61 955.26 80.17L956.26 82.13L973.04 71.43L972.29 69.84C966.86 58.29 957.55 52.44 944.63 52.44C937.01 52.44 930.82 54.93 925.67 60.08C920.71 65.18 918.2 71.46 918.2 78.72C917.9 97.52 934.62 104.57 943.6 108.36C949.12 110.7 955.69 114.45 955.69 119.06C955.69 125.73 952.72 128.7 946.04 128.7C938.57 128.7 933.38 123.23 930.18 111.99L929.45 109.42L912.59 120.03L912.86 121.38C914.35 128.83 918.14 135.23 924.15 140.43C930.17 145.5 937.4 148.06 945.65 148.06C964.28 148.06 976.31 136.32 976.31 118.18C976.46 100.98 960.08 93.77 950.35 89.48Z",
    fill: "#E62533"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMolliesIcoRed);
export default __webpack_public_path__ + "static/media/Mollies_Ico_Red.91a279e4ddd3e64a37b8be9c981a7d2c.svg";
export { ForwardRef as ReactComponent };